import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SessionAuthService } from '../services/session-auth.service';
import { ConfigService } from '../../core/services/config.service';

@Injectable()
export class SessionAuthInterceptor implements HttpInterceptor {

  constructor(
    private sessionAuthService: SessionAuthService,
    private router: Router,
    private configService: ConfigService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isAuthEndpoint(req.url)) {
      return next.handle(req);
    }

    const sessionToken = this.sessionAuthService.getSessionToken();

    if (sessionToken) {
      const authReq = req.clone({
        setHeaders: {
          'auth': sessionToken
        }
      });

      return next.handle(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
          return this.handleAuthError(error, req, next);
        })
      );
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        return this.handleAuthError(error, req, next);
      })
    );
  }

  private isAuthEndpoint(url: string): boolean {
    const authEndpoints = [
      '/api/AuthSession/create-session',
      '/api/AuthSession/validate-session',
      '/api/AuthSession/logout',
      '/api/AuthSession/logout-global'
    ];

    return authEndpoints.some(endpoint => url.includes(endpoint));
  }

  private handleAuthError(
    error: HttpErrorResponse,
    originalReq: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (error.status === 401) {
      console.warn('Session expired or invalid, performing logout');
      this.sessionAuthService.signOut().subscribe();
      return throwError(() => error);
    }

    if (error.status === 403) {
      console.warn('Access forbidden - insufficient permissions');
      return throwError(() => error);
    }

    return throwError(() => error);
  }
}
